import { useState } from 'react';

import { TextField } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';

// Payroll path of the access flow.
//
// Six characters, because that is what production checks. It has no payroll
// screen of its own: "Use Payroll ID instead" goes to the same invite-code page
// as the emailed code, and the value is submitted as an invite key, rejected
// unless it is exactly six long. "Payroll ID" is the default label — an
// organisation can rename it in its verification configuration.
const PAYROLL_ID_LENGTH = 6;

const PayrollIdScreen = ({
  onSubmit,
  onBack,
  error,
  account,
}: {
  onSubmit: (payrollId: string) => void;
  onBack: () => void;
  /** What the check said, under the field. See ACCESS_ERRORS. */
  error?: string;
  /** The app bar and its account sheet. See StepScreen. */
  account?: Account;
}) => {
  const [payrollId, setPayrollId] = useState('');

  return (
    <StepScreen
      title='Enter your payroll ID'
      description='This confirms your employer benefit.'
      primaryLabel='Continue'
      isPrimaryDisabled={payrollId.trim().length !== PAYROLL_ID_LENGTH}
      onPrimary={() => onSubmit(payrollId.trim())}
      onBack={onBack}
      account={account}
    >
      <TextField
        slotProps={{
          inputLabel: { shrink: true },
          htmlInput: { maxLength: PAYROLL_ID_LENGTH },
        }}
        label='Payroll ID'
        placeholder='e.g. 483920'
        variant='filled'
        value={payrollId}
        onChange={(e) => setPayrollId(e.target.value)}
        error={Boolean(error)}
        helperText={error ?? 'Six characters, on your payslip.'}
        fullWidth
      />
    </StepScreen>
  );
};

export default PayrollIdScreen;
